import * as React from 'react';

import cx from 'classnames';

import styles from './Heading.module.css';

type HeadingProps = {
  as?: 'h1' | 'h2' | 'h3' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  children: React.ReactNode;
  variant?: 'title' | 'small' | 'large';
};

export const Heading = ({
  as: Tag = 'h2',
  variant,
  className,
  children,
}: HeadingProps) => {
  return (
    <Tag className={cx(styles.heading, variant && styles[variant], className)}>
      {children}
    </Tag>
  );
};
